import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["url", "children", "target"];
import React from 'react';
import { Link } from 'gatsby';
export var LinkWrapper = function LinkWrapper(_ref) {
  var url = _ref.url,
      children = _ref.children,
      target = _ref.target,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  if (!url) return /*#__PURE__*/React.createElement(React.Fragment, null, children);

  if (/^(([a-z0-9]+:\/\/)|#)/i.test(url)) {
    return /*#__PURE__*/React.createElement("a", Object.assign({
      href: url
    }, rest, {
      target: target
    }), children);
  }

  return /*#__PURE__*/React.createElement(Link, Object.assign({
    to: url
  }, rest), children);
};